import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const YapilyStatusReplica = () => {
  const location = useLocation();

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [status, setStatus] = useState(null);
  const [bgcolor, setbgcolor] = useState();
  const [textcolor, settextcolor] = useState();
  const [message, setMessage] = useState();
  const [buttonColor, setButtonColor] = useState("from-gray-500 to-gray-600");
  const [buttonRing, setButtonRing] = useState("focus:ring-gray-400");



useEffect(() => {

  if (location.pathname.includes("/YapilyStatusReplica")) {

    const params = new URLSearchParams(location.search);

    const status = params.get("payment_status");

    setPaymentStatus(status);
    setStatus(status?.toLowerCase());

    if (status?.toLowerCase() === "pending") {
      setbgcolor("bg-red-50");
      settextcolor("text-red-700");
      setMessage("Oops! Something went wrong during your transaction. Please try again.");
      setButtonColor("from-red-500 to-red-600");
      setButtonRing("focus:ring-red-400");
    }
    else if (status?.toLowerCase() === "failed") {
      setbgcolor("bg-red-50");
      settextcolor("text-red-700");
      setMessage("Oops! Payment Failed.");
      setButtonColor("from-red-500 to-red-600");
      setButtonRing("focus:ring-red-400");
    }
    else if (status?.toLowerCase() === "completed") {
      setbgcolor("bg-green-50");
      settextcolor("text-green-700");
      setMessage("Thank you for your payment. Your transaction has been completed successfully.");
      setButtonColor("from-green-500 to-emerald-600");
      setButtonRing("focus:ring-green-400");
      sessionStorage.setItem("yapily_payment_success", "true");
    }
  }

}, [location]);

const handleRedirect = () => {

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isWebView = /(wv|WebView)/i.test(navigator.userAgent);

  if (isMobile || isWebView) {

    window.location.href = "fxmaster://payment-success";

    setTimeout(() => {
      window.location.href = "/BulkUploadReplica2";
    }, 2000);

  } else {
    window.location.href = "/BulkUploadReplica2";
  }
};



  return (
    <div className={`flex flex-col items-center justify-center h-screen ${bgcolor} p-6`}>
      {status == 'completed' ?
        <CheckCircle2 className={`${textcolor} w-20 h-20 mb-5`} />
        :
        <XCircle className="text-red-600 w-16 h-16 mb-4" />
      }
      <h1 className={`text-3xl font-bold mb-3 ${textcolor}`}>Payment {paymentStatus}!</h1>
      <p className="text-gray-700 text-center mb-8 max-w-md">
        {message}
      </p>

      <button
        // onClick={() => (window.location.href = '/transactions')}
         onClick={handleRedirect}
        className={`
    px-8 py-3 
    rounded-full 
    bg-gradient-to-r ${buttonColor}
    text-white 
    font-semibold 
    shadow-lg 
    hover:shadow-xl 
    transform hover:scale-105 
    transition-all 
    duration-300
    focus:outline-none 
    focus:ring-2 
    ${buttonRing}
    focus:ring-offset-2
  `}
      >
        Go Back to Dashboard
      </button>

    </div>
  );
};

export default YapilyStatusReplica;
